import React, { useEffect } from 'react';
import { Box, } from '@mui/material';
import { formatDateLong } from '../../../services/apiServices';


const tableStyles = {
    border: '1px solid black',
    padding: '8px',
};



const BLDraftPrintFirst = ({ invoiceData, companyBanks, shippingmark, shippingBooking, shipments, paymentVoucher, companyTaxes, termConditions, footer }) => {
    //   order detail  
    const companyFooter = shipments?.company?.companyFooter || '';
    const companyLogo = shipments?.company?.companyLogo || '';
    const invoiceDate = formatDateLong(invoiceData?.createdAt || "");
    const invoiceShippingmark = shippingmark?.shippingMark || '';
    const batchNo = shippingmark?.batchNo || '';
    const productName = shippingmark?.productsList?.productName || '';
    // Bank info
    const bankName = companyBanks?.bankName || '';
    const accountNumber = companyBanks?.accountNumber || '';
    const accountHolderName = companyBanks?.accountHolderName || '';
    const swiftCode = companyBanks?.swiftCode || '';
    const bankAddress = companyBanks?.bankAddress || '';
    const countryName = companyBanks?.country?.name || '';
    // ligal info
    const panNumber = companyTaxes?.panNumber || '';
    const iecNumber = companyTaxes?.iecNumber || '';
    const gstNumber = companyTaxes?.gstNumber || '';
    // shipments info
    const expectedEtd = shipments?.expectedEtd || '';
    const noOfContainers = shipments?.noOfContainers || '';
    const note = shipments?.note || '';
    const createdAt = shipments?.createdAt || '';
    // User info
    const userFirstName = shipments?.user?.firstName || '';
    const userLastName = shipments?.user?.lastName || '';
    const userFullName = `${userFirstName} ${userLastName}`.trim();
    // Company info
    const companyName = shipments?.company?.companyName || '';
    const companyMobile = shipments?.company?.mobile || '';
    const companyEmail = shipments?.company?.email || '';
    const companyAddress = shipments?.company?.address || '';
    const companyPincode = shipments?.company?.pincode || '';
    const companyWebsite = shipments?.company?.website || '';
    const companyTelephone = shipments?.company?.telephone || '';
    const baseCurrencyName = shipments?.company?.baseCurrencyData?.currency_name || '';
    const baseCurrencySymbol = shipments?.company?.baseCurrencyData?.currency_symbol || '';
    const companyCountry = shipments?.company?.country?.name || '';
    const companyState = shipments?.company?.state?.name || '';
    const companyCity = shipments?.company?.city?.name || '';
    const Signature = shipments?.company?.companySignStamp || '';

    const cifFobName = shipments?.cifFob?.cifFobName || '';
    const paymentMethodName = shipments?.paymentMethod?.paymentMethodName || '';
    const shipmentTypeName = shipments?.shipmentType?.shipmentTypeName || '';
    const currencyName = shipments?.currency?.currency_name || '';
    const currencySymbol = shipments?.currency?.currency_symbol || '';
    // Customer
    const customerName = shipments?.customer?.clientCompanyName || '';
    const customerMobile = shipments?.customer?.mobile || '';
    const customerEmail = shipments?.customer?.email || '';
    const billingStreet = shipments?.customer?.billingStreet || '';
    const billingPincode = shipments?.customer?.billingPincode || '';
    const billingCountry = shipments?.customer?.billingCountry?.name || '';
    const billingState = shipments?.customer?.billingState?.name || '';
    const billingCity = shipments?.customer?.billingCity?.name || '';

    const paymentMethod = invoiceData.paymentMethod || '';
    const blNumber = invoiceData.blNumber || '';
    const specialRequirement = invoiceData.specialRequirement || '';
    const orderMethod = invoiceData.orderMethod || '';
    const hsCode = invoiceData.hsCode || '';
    const notifyParty = invoiceData.notifyParty || '';
    const alsoNotify = invoiceData.alsoNotify || '';
    const oceanVesselVoyNo = invoiceData.oceanVesselVoyNo || '';
    const portOfLoading = `${invoiceData?.loading?.portName || ""}, ${invoiceData?.loading?.country?.name || ""}`.trim();
    const excessValueDeclaration = invoiceData.excessValueDeclaration || '';
    const portOfDestination = `${invoiceData?.destination?.portName || ""}, ${invoiceData?.destination?.country?.name || ""}`.trim();
    const finalDestination = invoiceData.finalDestination || '';
    const freightPayableAt = invoiceData.freightPayableAt || '';
    const noOfOriginals = invoiceData.noOfOriginals || '';
    const noOfPkgs = invoiceData.noOfPkgs || '';
    const descriptionOfGoods = invoiceData.descriptionOfGoods || '';
    const grossWeight = invoiceData.grossWeight || '';
    const measurement = invoiceData.measurement || '';
    const marks = invoiceData.marks || '';

    // Extract particulars from invoice data
    const particulars = invoiceData?.particulars || [];
    // Map the particulars data to a format suitable for the table
    const particularData = particulars.map((particular, index) => ({
        sealNo: particular.sealNo || '',
        type: particular.type || '',
        noOfPkgs: particular.noOfPkgs || '',
        grossWeight: particular.grossWeight || '',
        measurement: particular.measurement || '',
    }));

    const sumNoOfPkgs = particularData.reduce((total, item) => {
        return total + Number(item.noOfPkgs || 0);
    }, 0);

    return (
        <>
            <div style={{
                fontSize: "12px",
                textTransform: "capitalize",
                lineHeight: "150%",
                opacity: 1,
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
            }}>
                <div
                    style={{
                        display: footer ? 'flex' : 'none',
                        justifyContent: 'flex-end',
                        alignItems: 'flex-start',
                        width: '100%',
                    }}
                >
                    <Box
                        component="img"
                        src={companyLogo}
                        style={{
                            maxWidth: '100px',
                            width: '100%',
                            height: 'auto',
                            objectFit: 'cover',
                        }}
                    />
                </div>

                <div style={{ position: 'relative', padding: '0px', }}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center',
                            marginBottom: "10px"
                        }}
                    >
                        <p style={{ fontWeight: 'bold', fontSize: '14px', margin: 0, textTransform: "uppercase" }}>Bl Draft</p>
                    </div>
                    <table
                        border='1px solid #5A5A5A'
                        cellPadding="8"
                        cellSpacing="0"
                        style={{ width: '100%', textTransform: "capitalize", fontSize: "12px", borderCollapse: 'collapse', border: '1px solid #5A5A5A' }}
                    >
                        <thead  >
                            <tr>
                                <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#ededed" }}>Shipper</th>
                                <th colSpan={2} style={{ textAlign: "right", backgroundColor: "#ededed", }}>Payment Method</th>
                                <th colSpan={2} style={{ textAlign: "left", fontWeight: "500" }}>{paymentMethod}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={2} rowspan={3}>
                                    {companyName}<br />
                                    {companyAddress && `${companyAddress},`}  <br />
                                    {[companyCity, companyState, companyCountry].filter(Boolean).join(', ')}
                                    {companyPincode && ` - ${companyPincode}`}
                                </td>

                                <td style={{ textAlign: "right", backgroundColor: "#ededed", fontWeight: "bold" }} colSpan={2}>BL Number</td>
                                <td colSpan={2}>{blNumber}</td>
                            </tr>
                            <tr>
                                <td style={{ backgroundColor: "#ededed", textAlign: "right", fontWeight: "bold" }} colSpan={2}  >Order Method</td>
                                <td colSpan={2}>{orderMethod}</td>
                            </tr>
                        </tbody>

                        <thead style={{ backgroundColor: "#ededed" }}>
                            <tr>
                                <th colspan="2" style={{ textAlign: "left" }}>Consignee</th>
                                <th style={{ textAlign: "left" }} colspan="5" rowspan="1">HS Code</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ verticalAlign: "top" }}>
                                <td rowspan="4" colspan="2">
                                    {customerName} <br />
                                    <span>
                                        {billingStreet && `${billingStreet},`}
                                        <br />
                                        {[billingCity, billingState, billingCountry].filter(Boolean).join(', ')}
                                        {billingPincode && ` - ${billingPincode}`}

                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">{hsCode}</td>
                            </tr>
                            <tr style={{ backgroundColor: "#ededed" }} >
                                <td colspan="5">Please Indicate any special requirement below</td>
                            </tr>
                            <tr>
                                <td colspan="5">{specialRequirement}</td>
                            </tr>
                        </tbody>
                        <thead  >
                            <tr>
                                <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#ededed" }}>Notify Part</th>
                                <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#ededed", }}>Acess value declartion    </th>
                                <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#ededed" }}> Ocean vessel</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ verticalAlign: "top" }}>
                                <td colSpan={2} rowspan={3}
                                    style={{
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word',
                                        padding: '8px',
                                        border: '1px solid black',
                                        width: '200px'
                                    }}>
                                    {notifyParty}
                                </td>

                                <td style={{ textAlign: "left", verticalAlign: "top" }} colSpan={2}>{excessValueDeclaration}</td>
                                <td style={{ verticalAlign: "top" }} colSpan={2}>{oceanVesselVoyNo}</td>
                            </tr>
                        </tbody>
                        <thead  >
                            <tr>
                                <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#ededed" }}>Also Notify</th>
                                <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#ededed", }}>Port of Loading    </th>
                                <th colSpan={2} style={{ textAlign: "left", backgroundColor: "#ededed" }}> port Of Destination</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ verticalAlign: "top" }}>
                                <td colSpan={2} rowspan={3}
                                    style={{
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word',
                                        padding: '8px',
                                        border: '1px solid black',
                                        width: '200px'
                                    }}>
                                    {alsoNotify}
                                </td>

                                <td style={{ textAlign: "left", verticalAlign: "top" }} colSpan={2}>{portOfLoading}</td>
                                <td style={{ verticalAlign: "top" }} colSpan={2}>{portOfDestination}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table
                        cellPadding="8"
                        cellSpacing="0"
                        border='1px solid #5A5A5A'
                        style={{
                            width: '100%',
                            textTransform: 'capitalize',
                            fontSize: '12px',
                            borderCollapse: 'collapse',
                            border: '1px solid #5A5A5A',
                            borderTop: '0',
                        }}
                    >
                        <thead style={{ backgroundColor: '#ededed' }}>
                            <tr>
                                <th colSpan={2} style={{ textAlign: 'left', borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>
                                    Final destination
                                </th>
                                <th colSpan={1} style={{ textAlign: 'left', borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>
                                    Freight Payable at
                                </th>
                                <th colSpan={3} style={{ textAlign: 'left', borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>
                                    No. of Originals
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={2}>{finalDestination} </td>
                                <td colSpan={1}>{freightPayableAt}</td>
                                <td colSpan={3}>{noOfOriginals}</td>
                            </tr>
                        </tbody>

                        <thead style={{ backgroundColor: "#ededed" }}>
                            <tr>
                                <th style={{ textAlign: "left", width: "20%" }}>Mark</th>
                                <th style={{ textAlign: "left", width: "10%" }}>no. of pkgs</th>
                                <th style={{ textAlign: "left", width: "40%" }}>description of good</th>
                                <th style={{ textAlign: "left", width: "10%" }}>Gross weight</th>
                                <th style={{ textAlign: "left", width: "10%" }}>Measurement</th>
                            </tr>
                        </thead>

                        <tbody style={{ height: "200px", verticalAlign: "top" }}>
                            <tr>
                                <td>{marks}</td>
                                <td>{noOfPkgs}</td>
                                <td   >{descriptionOfGoods}</td>
                                <td>{grossWeight}</td>
                                <td>{measurement}</td>
                            </tr>
                        </tbody>
                        <tbody>
                            <tr>
                                <td colSpan={5} style={{ textAlign: 'center', }}>
                                    The following is the corresponding box information that needs to be
                                    <br />
                                    <br />
                                    filled in. Please fill it out clearly according to the actual situation.
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table
                        cellPadding="8"
                        cellSpacing="0"
                        border='1px solid #5A5A5A'
                        style={{
                            width: '100%',
                            textTransform: 'capitalize',
                            fontSize: '12px',
                            borderCollapse: 'collapse',
                            border: '1px solid #5A5A5A',
                            borderTop: '0',
                        }}
                    >
                        <thead style={{ backgroundColor: "#ededed" }}>
                            <tr>
                                {/* <th style={{ textAlign: "left", borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>Container No</th> */}
                                <th style={{ textAlign: "left", borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>seal no.</th>
                                <th style={{ textAlign: "left", borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>Type</th>
                                <th style={{ textAlign: "left", borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>no of pkgs</th>
                                <th style={{ textAlign: "left", borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>gross weight</th>
                                <th style={{ textAlign: "left", borderTop: 'none', borderBottom: '1px solid #5A5A5A' }}>Measurement</th>
                            </tr>
                        </thead>
                        <tbody>
                            {particularData.map((row, index) => (
                                <tr key={index}>
                                    {/* <td> </td> */}
                                    <td>{row.sealNo}</td>
                                    <td>{row.type}</td>
                                    <td>{row.noOfPkgs}</td>
                                    <td>{row.grossWeight}</td>
                                    <td>{row.measurement}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div
                        component="footer"
                        style={{
                            display: footer ? 'block' : 'none',
                            width: '100%',
                            textAlign: 'center',
                            marginTop: '10px',
                            boxSizing: 'border-box',
                        }}
                    >
                        <Box
                            component="img"
                            src={companyFooter}

                            style={{
                                maxWidth: '100%',
                                height: 'auto',
                                objectFit: 'cover',
                            }}
                        />
                    </div>
                </div>
            </div >
        </>

    );
};


// Export both functions   
export {
    BLDraftPrintFirst,
};
